import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { CpoCard } from 'src/shared/cpo-card/cpo.card';
import { Snackbar } from 'src/shared/snackbar/snackbar';
import { Stack, Button } from '@mui/material';
import { useLayoutEffect, useMemo } from 'react';
import { useSetPageActionContext } from 'src/shared/layout/page-layout/page-layout.context-provider';
import { useGetCpoByIdQuery } from '@service/cpo.service';
import { usePullCpoLocations } from '../cpo-pull-locations/use-pull-cpo-locations';

export function CpoDetail(): React.JSX.Element {
  const { cpoId } = useParams();
  const { t } = useTranslation();
  const setPageAction = useSetPageActionContext();

  const {
    data: cpo,
    isLoading: isLoadingCpo,
    isError: isCpoError,
  } = useGetCpoByIdQuery(cpoId!, {
    skip: !cpoId,
  });

  const {
    handleFetch,
    isLoading: isPullLoading,
    isError: isPullError,
    status: pullStatus,
    message: pullMessage,
  } = usePullCpoLocations(cpoId ?? '');

  const pullCpoLocationsButton = useMemo(() => {
    if (cpoId) {
      return (
        <div key="pull-cpo-locations">
          <Button
            variant="contained"
            onClick={handleFetch}
            disabled={isPullLoading}>
            Pull CPO Locations
          </Button>
          {isPullError && (
            <Snackbar
              variant="error"
              message={t('error.get-one-cpo-query', {
                pullStatus,
                pullMessage,
              })}
            />
          )}
        </div>
      );
    }
    return null;
  }, [
    cpoId,
    handleFetch,
    isPullLoading,
    isPullError,
    pullMessage,
    pullStatus,
    t,
  ]);

  useLayoutEffect(() => {
    setPageAction([pullCpoLocationsButton]);
  }, [pullCpoLocationsButton, setPageAction]);

  return (
    <>
      <Stack direction="row" gap={4} flexWrap="wrap">
        <CpoCard isPending={isLoadingCpo} {...cpo} sx={{ width: 750 }} />
      </Stack>

      {isCpoError && (
        <Snackbar variant="error" message={t('error.get-one-cpo-query')} />
      )}
    </>
  );
}
